import type { TranslationDict } from './ja'

export const de: TranslationDict = {
  appTitle: 'Lucky Animal Territory',
  help: 'Spielanleitung',
  helpAria: 'Spielanleitung',
  settings: 'Einstellungen',
  settingsAria: 'Einstellungen',
  close: 'Schließen',
  closeAria: 'Schließen',
  player: 'Spieler',
  highscore: 'Bestwert',
  start: 'Spiel starten',
  staminaEmpty: 'Nicht genug Ausdauer',
  ranking: 'Revierkampf',
  difficultyTitle: 'Schwierigkeit wählen',
  difficultyStart: 'Mit dieser Schwierigkeit starten',
  back: 'Zurück',
  today: 'Heute',
  weekly: 'Diese Woche',
  alltime: 'Gesamt',
  loading: 'Lädt...',
  noScores: 'Noch keine Ergebnisse. Werde der erste Revierkönig!',
  loadFailed: 'Laden fehlgeschlagen',
  you: 'Du',
  youConstant: 'DU',
  language: 'Sprache',
  languageNote: 'Unterstützt 18 Sprachen einschließlich Japanisch.',
  bgm: 'BGM',
  se: 'Soundeffekte',
  soundEnableAria: 'Ton einschalten',
  soundDisableAria: 'Ton ausschalten',
  adWatch: 'Werbung bis zum Ende ansehen',
  adCancel: 'Nicht jetzt',
  rankSuffix: '.',
  earnedPoints: 'hat {score} Pkt. erzielt',
  helpGoalTitle: '🎯 Ziel',
  helpGoalText: 'Platziere Steine auf dem 9x9-Feld und vergrößere dein zusammenhängendes Revier. Wer am Ende die meisten Punkte hat, gewinnt.',
  helpWinTitle: '🏆 Siegbedingungen',
  helpWinFive: 'Bilde eine Reihe von fünf Steinen (horizontal, vertikal oder diagonal) für einen sofortigen Sieg.',
  helpWinScore: 'Wenn das Feld voll ist, gewinnt der höhere Punktestand. Es gibt kein Unentschieden.',
  helpScoreTitle: '💯 Punktevergabe',
  helpLineBonus: 'Linien-Bonus: Erhalte Punkte für 3er-, 4er- und 5er-Reihen.',
  helpClusterBonus: 'Revier-Bonus: Erziele mehr Punkte, wenn deine zusammenhängenden Gruppen wachsen.',
  helpKomi: 'Komi: Der zweite Spieler erhält einen Punkte-Bonus von +10%.',
  helpControlsTitle: '🖱️ Steuerung',
  helpControlsText: 'Wenn du am Zug bist, tippe auf ein leeres Feld, um einen Stein zu setzen.',
  helpTipsTitle: '💡 Tipps',
  helpTipHell: 'Probiere HELL, wenn du die ultimative Herausforderung suchst.',
  helpTipCluster: 'Jage nicht nur 5er-Reihen nach. Größere zusammenhängende Gruppen erhöhen ebenfalls deinen Punktestand.',
  resultWinFive: '🎉 Fünf in einer Reihe! Du hast gewonnen!',
  resultWinScore: '🎉 Sieg nach Punkten! Du hast gewonnen!',
  resultLoseFive: '😿 Die CPU hat fünf in einer Reihe!',
  resultLoseScore: '😿 Niederlage nach Punkten. Versuch es nochmal!',
  resultDraw: '🤝 Unentschieden',
  newHighscore: '🏆 Neuer Bestwert!',
  scoreNone: 'Kein Ergebnis',
  clusterBonus: 'Revier-Bonus',
  retry: 'Nochmal spielen',
  titleBack: 'Titel',
  scoreHintPlaceStone: 'Setze einen Stein',
  best: 'Bestleistung',
  clusterUnit: 'Gruppe',
  lineCount: '{len}er-Reihe x{count}',
  turnCount: 'Zug {count} · {difficulty}',
  boardPlayerPiece: 'Dein Stein',
  boardCpuPiece: 'CPU-Stein',
  boardPlayerAlt: 'Du',
  boardCpuAlt: 'CPU',
  boardCellPosition: 'Reihe {row}, Spalte {col}',
  boardPlaceable: 'setzbar',
  boardEmpty: 'leeres Feld',
  boardFlower: 'mit Blume',
  firstPlayerAlt: 'Erster Spieler',
  playerFirst: 'Du beginnst!',
  playerSecond: 'Du bist als Zweiter dran (+{bonus}% Komi)',
  cpuFirst: 'CPU beginnt!',
  finalePlayerWin: 'Du gewinnst!',
  finaleCpuWin: 'CPU gewinnt!',
  finaleFive: 'Fünf in einer Reihe!',
  finaleTerritory: 'Revierkampf!',
  winnerAlt: 'Sieger',
  loadingBoot: 'Startet...',
  loadingConnect: 'Verbindet...',
  loadingProfile: 'Profil wird geladen...',
  loadingAssets: 'Ressourcen werden geladen...',
  loadingReady: 'Bereit',
  reauthRequiredTitle: 'Anmeldung erforderlich',
  startupFailedTitle: 'Start fehlgeschlagen',
  reauthButton: 'Erneut anmelden',
  reloadButton: 'Neu laden',
  lineReloginButton: 'LINE-Login',
  reauthReason: 'Deine Sitzung ist abgelaufen. Bitte melde dich erneut an.',
  errorReauth: 'Deine Sitzung ist abgelaufen. Bitte melde dich erneut an.',
  errorForbidden: 'Du hast keine Berechtigung für dieses Spiel.',
  errorNotFound: 'Spieldaten wurden nicht gefunden.',
  errorRateLimited: 'Das Netzwerk ist überlastet. Bitte warte kurz und versuch es erneut.',
  errorServer: 'Verbindung zum Server fehlgeschlagen. Bitte warte kurz und lade neu.',
  errorCommunication: 'Ein Kommunikationsfehler ist aufgetreten. Bitte lade neu.',
  errorNetwork: 'Netzwerkverbindung fehlgeschlagen. Prüfe deine Verbindung und lade neu.',
  errorStartup: 'Start fehlgeschlagen. Bitte lade neu.',
  settingsTabGeneral: 'Einstellungen',
  settingsTabAccount: 'Konto',
  settingsTabInfo: 'Info',
  account: 'Konto',
  linked: 'Verknüpft',
  guest: 'Gast',
  loggedInWith: 'Angemeldet über {provider}',
  loggedIn: 'Angemeldet',
  playingAsGuest: 'Du spielst zurzeit als Gast.',
  appleLoginBusy: 'Anmeldung bei Apple...',
  appleLogin: 'Mit Apple anmelden',
  googleLoginBusy: 'Anmeldung bei Google...',
  googleLogin: 'Mit Google anmelden',
  logoutBusy: 'Abmeldung...',
  logout: 'Abmelden',
  logoutSuccess: 'Abgemeldet',
  logoutFailed: 'Abmeldung fehlgeschlagen',
  appInfo: 'App-Informationen',
  appName: 'App-Name',
  version: 'Version',
  legalInfo: 'Rechtliches',
  terms: 'Nutzungsbedingungen',
  privacy: 'Datenschutz',
  operator: 'Betreiber',
  contact: 'Kontakt',
  copyTap: 'Zum Kopieren tippen',
  idCopied: 'ID kopiert',
  copyFailed: 'Kopieren fehlgeschlagen',
  other: 'Sonstiges',
  reportAd: 'Unangemessene Werbung melden',
  privacyChoices: 'Ad privacy choices',
  profileEdit: 'Profil bearbeiten',
  displayName: 'Anzeigename',
  displayNamePlaceholder: 'Namen eingeben',
  chooseIcon: 'Symbol wählen',
  iconLoadFailed: 'Symbole konnten nicht geladen werden.',
  saveFailed: 'Speichern fehlgeschlagen. Bitte versuch es erneut.',
  noIcons: 'Keine Symbole verfügbar.',
  save: 'Speichern',
  saving: 'Speichert...',
  staminaAria: 'Ausdauer {stamina} / {max}',
  nextRecovery: 'Nächste Erholung in {time}',
  adPlaying: 'Werbung läuft...',
  recoverFullAd: 'Werbung ansehen, um Ausdauer vollständig aufzufüllen',
  dailyBonusAria: 'Werbung bis zum Ende ansehen für +5 Ausdauer',
  dailyBonusAd: 'Werbung ansehen für +5 Ausdauer',
  legalLastUpdated: 'Zuletzt aktualisiert: {date}',
  privacyTitle: 'Datenschutzerklärung',
  termsTitle: 'Nutzungsbedingungen',
  adPlayingAria: 'Werbung wird abgespielt',
  adBadge: '▶ Werbung',
  adRemaining: 'Noch {seconds}s',
  adDevHint: 'Testwerbung. In der Produktion wird ein AdMob-Video abgespielt.',
  adRewardRequirement: 'Sieh dir die Werbung bis zum Ende an, um diese Belohnung zu erhalten.',
  adRewardStaminaDetail: 'Belohnung: Ausdauer bis zum Maximum auffüllen',
  adRewardDailyBonusDetail: 'Belohnung: +{amount} Ausdauer als heutiger Tagesbonus',
  adRewardIncompleteNote: 'Wenn du vorher schließt, erhältst du keine Belohnung.',
  adSkipAria: 'Werbung überspringen',
  adSkip: 'Überspringen ✕',
  adSkipAfter: 'Überspringen in {seconds}s',
  offlineMessage: 'Verbindung zum Server fehlgeschlagen. Einige Funktionen sind nicht verfügbar.',
  reconnecting: 'Verbindung wird wiederhergestellt...',
  reconnect: 'Neu verbinden',
  signInTitle: 'Anmelden',
  signInBusy: 'Anmeldung...',
  signInCancelNote: 'Wenn du die Anmeldung abbrichst, kannst du als Gast weiterspielen (eingeschränkte Funktionen).',
  processing: 'Verarbeitung...',
  recoverConfirmTitle: 'Datenüberschreibung bestätigen',
  recoverConfirmMessage: 'Mit dieser Anmeldung sind bereits Daten verknüpft. Fortfahren überschreibt die Gastdaten auf diesem Gerät. Möchtest du fortfahren?',
  recoverConfirmContinue: 'Wiederherstellen',
  recoverConfirmCancel: 'Abbrechen',
  unlinkConfirmTitle: 'Konto entknüpfen',
  unlinkConfirmMessage: 'Wenn du diesen Anbieter entknüpfst, kehrst du zum Gastmodus zurück. Deine Hub-Daten bleiben erhalten, wenn du dich erneut mit demselben Anbieter anmeldest.',
  unlinkConfirmContinue: 'Entknüpfen',
  unlinkConfirmCancel: 'Abbrechen',
  deleteConfirmTitle: 'Kontolöschung bestätigen',
  deleteConfirmMessage: 'Das Löschen deines Kontos entfernt alle Bestwerte, Anmeldedaten, verknüpften Konten und Einladungen.\nDieser Schritt kann nicht rückgängig gemacht werden. Wirklich löschen?',
  deleteConfirmContinue: 'Konto löschen',
  deleteConfirmCancel: 'Abbrechen',
  adNekoTitle: 'AD Neko',
  matchmakingRemaining: 'Noch {seconds}s',
  matchmakingTimeoutMessage: 'Kein Gegner rechtzeitig gefunden. Bitte versuch es erneut.',
  difficultyEasyName: 'Locker',
  difficultyEasyDescription: 'Der Gegner ist etwas abgelenkt',
  difficultyNormalName: 'Normal',
  difficultyNormalDescription: 'Der Gegner macht manchmal Fehler',
  difficultyHardName: 'Schwer',
  difficultyHardDescription: 'Der Gegner hat das Feld gut im Blick',
  difficultyHellName: 'Extrem',
  difficultyHellDescription: 'Der Gegner ist stark und plant voraus',
}
